import React, { useState , useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import ButtonElement from "../../../Common/ButtonElement";
import TableComponent from "../../components/TableComponent";
import { TiPencil } from "react-icons/ti";
import { RiDeleteBin5Line } from "react-icons/ri";
import RoleModal from "./RoleModal";
import SearchBox from "../../components/SearchComponent";
import { DELETE_POP_UP } from "../../../utils";
import { useApiRequest } from "../../../hooks/useApiRequest";
import { appApis } from "../../../constants";
import { getUserRoles } from "../../../actions/installer";
import { userAllowedPages } from "../../../actions/auth";

// Header for the columns in the table
const headers = [
  { name: "ROLE NAME" },
  { name: "ACTIONS"}
];

const UserRoles = () => {
  const [roles, setRoles] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [search, setSearch] = useState("");
  const [pages, setPages] = useState([]);
  const { request: apiRequest, loading } = useApiRequest();
  const { filters, userData } = useSelector(({ inventory, userDetails }) => ({
    filters: inventory.filters,
    userData: userDetails?.data
  }), shallowEqual);

  const dispatch = useDispatch();

  // GET - Fetch all roles (concise, with optional chaining)
  const fetchRoles = () => {
    dispatch(getUserRoles());
    dispatch(userAllowedPages(userData?.id));
  };

  // Fetch pages (separate function)
  const fetchPages = () => {
    apiRequest({
      url: appApis.pages,
      showToast : false,
      onSuccess: (response) => {
        setPages(response?.data || []);
      }
    });
  };

  // Open modal for create or edit
  const openRoleModal = (role = null) => {
    setSelectedRole(role);
    setShowModal(true);
  };

  // DELETE - Delete a role
  const handleDeleteRole = (roleId) => {
    DELETE_POP_UP(() => {
      apiRequest({
        url: `${appApis.deleteRole}/${roleId}`,
        method: "DELETE",
        showToast : true,
        onSuccess: fetchRoles
      });
    });
  };
  
  // Filter roles based on search
  const filteredRoles = useMemo(() => roles.filter(role =>
    role.role_name?.toLowerCase().includes(search.toLowerCase())
  ), [roles]);

  useEffect(() => {
    setRoles(filters?.userRoles || []);
  }, [filters?.userRoles])

  useEffect(() => {
    fetchPages();
  }, []);

  return (
    <>
      <SearchBox
        className="mb-3"
        placeholder="Search here..."
        value={search}
        onChange={e => setSearch(e.target.value)}
      />
      <TableComponent
        title={"User Roles"}
        col={3}
        headers={headers}
        data={filteredRoles}
        tableLoading={loading}
        render={(tdData, index) => <tr key={index}>
          <td>{(index ?? 0) + 1}</td>
          <td>{tdData?.role_name ?? "-"}</td>
          <td>
            <ButtonElement
              text={<TiPencil size={20} />}
              cssClass="more-radius mx-1 px-4"
              variant="btn-outline-edit"
              onClick={() => openRoleModal(tdData)}
              title="Edit"
            />
            <ButtonElement
              text={<RiDeleteBin5Line size={20} />}
              cssClass="more-radius px-4"
              variant="btn-delete-icon"
              onClick={() => handleDeleteRole(tdData.role_id)}
              title="Delete"
            />
          </td>
        </tr>}
        FilterComponent={
          <div className="d-flex justify-content-end">
            <ButtonElement
              text={"Create Role"}
              cssClass="small-radius ms-2 mb-1"
              variant="btn-black"
              onClick={() => openRoleModal(null)}
            />
          </div>
        }
      />
      <RoleModal
        show={showModal}
        onHide={() => setShowModal(false)}
        role={selectedRole}
        pages={pages}
        refreshRoles={fetchRoles}
      />
    </>
  );
};

export default UserRoles;         